import * as GC from '@grapecity/spread-sheets';
import { addDefinitionValidator, addInterpolationValidator } from './validators';
import {
  DEFINITION_COL_POS,
  DIM1_GROUP,
  DIM2_GROUP,
  DIM3_GROUP,
  DISABLED_CELL_STYLE,
  INTERPOLATION_COL_POS
} from './constants';

export const disableEmptyDimensionsCells = (
  sheet: GC.Spread.Sheets.Worksheet,
  interpolation,
  dimensionDefinition,
  row: any,
  amount: any
) => {
  switch (amount) {
    case 1:
      for (let x = DIM2_GROUP.startCol; x < DIM2_GROUP.startCol + DIM2_GROUP.spanCol + DIM3_GROUP.spanCol; x++) {
        sheet.setStyle(row, x, DISABLED_CELL_STYLE);
        sheet.getCell(row, x).value(null);
        sheet.setDataValidator(row, x, null);
      }
      for (let x = DIM1_GROUP.startCol; x < DIM1_GROUP.startCol + DIM1_GROUP.spanCol; x++) {
        sheet.setStyle(row, x, sheet.getDefaultStyle());
      }
      addInterpolationValidator(sheet, interpolation, row, DIM1_GROUP.startCol + INTERPOLATION_COL_POS);
      addDefinitionValidator(sheet, dimensionDefinition, row, DIM1_GROUP.startCol + DEFINITION_COL_POS);
      break;
    case 2:
      for (let x = DIM1_GROUP.startCol; x < DIM1_GROUP.startCol + DIM1_GROUP.spanCol + DIM2_GROUP.spanCol; x++) {
        sheet.setStyle(row, x, sheet.getDefaultStyle());
        addInterpolationValidator(sheet, interpolation, row, DIM1_GROUP.startCol + INTERPOLATION_COL_POS);
        addDefinitionValidator(sheet, dimensionDefinition, row, DIM1_GROUP.startCol + DEFINITION_COL_POS);
        addInterpolationValidator(sheet, interpolation, row, DIM2_GROUP.startCol + INTERPOLATION_COL_POS);
        addDefinitionValidator(sheet, dimensionDefinition, row, DIM2_GROUP.startCol + DEFINITION_COL_POS);
      }
      for (let x = DIM3_GROUP.startCol; x < DIM3_GROUP.startCol + DIM3_GROUP.spanCol; x++) {
        sheet.setStyle(row, x, DISABLED_CELL_STYLE);
        sheet.getCell(row, x).value(null);
        sheet.setDataValidator(row, x, null);
      }
      break;
    case 3:
      for (
        let x = DIM1_GROUP.startCol;
        x < DIM1_GROUP.startCol + DIM1_GROUP.spanCol + DIM2_GROUP.spanCol + DIM3_GROUP.spanCol;
        x++
      ) {
        sheet.setStyle(row, x, sheet.getDefaultStyle());
      }
      addInterpolationValidator(sheet, interpolation, row, DIM1_GROUP.startCol + INTERPOLATION_COL_POS);
      addInterpolationValidator(sheet, interpolation, row, DIM2_GROUP.startCol + INTERPOLATION_COL_POS);
      addInterpolationValidator(sheet, interpolation, row, DIM3_GROUP.startCol + INTERPOLATION_COL_POS);
      addDefinitionValidator(sheet, dimensionDefinition, row, DIM1_GROUP.startCol + DEFINITION_COL_POS);
      addDefinitionValidator(sheet, dimensionDefinition, row, DIM2_GROUP.startCol + DEFINITION_COL_POS);
      addDefinitionValidator(sheet, dimensionDefinition, row, DIM3_GROUP.startCol + DEFINITION_COL_POS);
      break;
    default:
      for (
        let x = DIM1_GROUP.startCol;
        x < DIM1_GROUP.startCol + DIM1_GROUP.spanCol + DIM2_GROUP.spanCol + DIM3_GROUP.spanCol;
        x++
      ) {
        sheet.setStyle(row, x, DISABLED_CELL_STYLE);
        sheet.getCell(row, x).value(null);
        sheet.setDataValidator(row, x, null);
      }
  }
};
